import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { MatchdayWinners } from '../models/matchday-winners-models';

/** Events of the matchday-winners region: the per-fixture winner list shown on the prizes tab. */
export const matchdayWinnersEvents = eventGroup({
  source: 'MatchdayWinners',
  events: {
    loadMatchdayWinners: type<void>(),
    loadMatchdayWinnersSuccess: type<{ matchdays: MatchdayWinners[] }>(),
    loadMatchdayWinnersFailed: type<{ error: string }>(),
  },
});
